import React, { useState } from "react";

const DireccionEntrega = ({direcciones, form, handleInputChange}) => {
	const setDireccion = (dir) => handleInputChange(dir, 'direccion_entrega');

	const onBtnClick = () => {
		if (form?.direccion_entrega) {
			setDireccion(undefined);
		} else {
			if (direcciones.length === 1) {
				setDireccion(direcciones[0]);
			}
		}
	};

	const selected = !!form?.direccion_entrega;

	return (
		<div className={`dropdown mb-auto`}>
			<button type="button" className={`au-btn au-btn-icon direccion-entrega-btn ${selected ? 'au-btn--green au-btn--small' : 'au-btn-filter'}`} onClick={onBtnClick} style={{height: "38px"}}>
				<svg className="m-auto icon-hover-white" style={{height: "16px", width: "16px", fill: selected ? "#fff" : "#808080"}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M64 160C64 124.7 92.7 96 128 96L416 96C451.3 96 480 124.7 480 160L480 192L530.7 192C547.7 192 564 198.7 576 210.7L621.3 256C633.3 268 640 284.3 640 301.3L640 448C640 483.3 611.3 512 576 512L572.7 512C562.3 548.9 528.3 576 488 576C447.7 576 413.8 548.9 403.3 512L300.7 512C290.3 548.9 256.3 576 216 576C175.7 576 141.8 548.9 131.3 512L128 512C92.7 512 64 483.3 64 448L64 400L24 400C10.7 400 0 389.3 0 376C0 362.7 10.7 352 24 352L136 352C149.3 352 160 341.3 160 328C160 314.7 149.3 304 136 304L24 304C10.7 304 0 293.3 0 280C0 266.7 10.7 256 24 256L200 256C213.3 256 224 245.3 224 232C224 218.7 213.3 208 200 208L24 208C10.7 208 0 197.3 0 184C0 170.7 10.7 160 24 160L64 160zM576 352L576 301.3L530.7 256L480 256L480 352L576 352zM256 488C256 465.9 238.1 448 216 448C193.9 448 176 465.9 176 488C176 510.1 193.9 528 216 528C238.1 528 256 510.1 256 488zM488 528C510.1 528 528 510.1 528 488C528 465.9 510.1 448 488 448C465.9 448 448 465.9 448 488C448 510.1 465.9 528 488 528z"/></svg>
			</button>
			{direcciones?.length > 1 && <div
				style={{zIndex: "99", maxWidth: "80vw", overflow: "auto", maxHeight: "50vh"}}
				className={`dropdown-menu dp-left`}
			>
				{direcciones?.map((dir) => {
                    const sel = dir.direccion === form?.direccion_entrega?.direccion;
                    return (
                        <a onClick={() => setDireccion(dir)} className="dropdown-item" style={{cursor: "pointer"}} rel="noreferrer">
                            {sel ? (<i className="zmdi zmdi-check color-primary"></i>) : ''} {dir.direccion}
                        </a>
                    )
})}
			</div>}
		</div>
	);
};

export default DireccionEntrega;
